import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-area-filter',
    templateUrl: './area-filter.component.html',
    styleUrls: ['./area-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AreaFilterComponent implements OnInit, OnChanges {
    @Output() resetButtonClick = new EventEmitter<void>();
    @Output() areaSelectClick = new EventEmitter<void>();

    @Input() shapeTypes: ShapeType[] = [];
    @Input() areaSelectLabel: string = '';

    @Input() selectedShapeTypeId: number = 1;
    @Output() selectedShapeTypeIdChange = new EventEmitter<number>();

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {}

    onResetButtonClick(): void {
        this.resetButtonClick.emit();
    }

    onShapeTypeChange(shapeType: ShapeType): void {
        this.selectedShapeTypeId = shapeType.id;
        this.selectedShapeTypeIdChange.emit(shapeType.id);
    }

    onAreaClick(): void {
        this.areaSelectClick.emit();
    }
}

type ShapeType = {
    id: number;
    value: string;
};
